import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import m2gNcsBanner from './m2gNcsBanner.webp';
import profile1 from './profile1.png';
import profile2 from './profile2.png';

const useStyles = makeStyles(theme => ({
  banner: {
    backgroundColor: '#ffc220',
    width: '100%',
    minHeight: 70,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 24px',
    boxSizing: 'border-box',
    gap: 16,
    [theme.breakpoints.down('md')]: {
      padding: '8px 16px',
      minHeight: 'unset',
      gap: 8,
    },
  },
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minWidth: 0,
  },
  textPrimary: {
    fontFamily: 'sans-serif',
    fontSize: 20,
    color: '#212121',
    marginBottom: 2,
    lineHeight: 1.3,
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
    },
  },
  textSecondary: {
    fontFamily: 'sans-serif',
    fontSize: 22,
    color: '#ffffff',
    lineHeight: 1.3,
    [theme.breakpoints.down('md')]: {
      fontSize: 15,
    },
  },
  profileImgsWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  profileImg: {
    width: 62,
    height: 62,
    borderRadius: '50%',
    objectFit: 'cover',
    marginLeft: -14,
    border: '2px solid #fff',
    [theme.breakpoints.down('md')]: {
      width: 44,
      height: 44,
    },
  },
  mentorToGoLogo: {
    height: 56,
    width: 'auto',
    objectFit: 'contain',
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      height: 40,
    },
    [theme.breakpoints.down('sm')]: {
      height: 32,
    },
  },
}));

const NcsBanner = () => {
  const classes = useStyles();
  return (
    <div className={classes.banner}>
      <div className={classes.textBlock}>
        <span className={classes.textPrimary}>
          Your mentorship is a few steps away
        </span>
        <span className={classes.textSecondary}>
          <b>Get mentored by industry experts!!</b>
        </span>
      </div>
      <div className={classes.profileImgsWrapper}>
        <img src={profile1} className={classes.profileImg} alt="Profile 1" />
        <img src={profile2} className={classes.profileImg} alt="Profile 2" />
      </div>
      <img src={m2gNcsBanner} className={classes.mentorToGoLogo} alt="Mentor To Go" />
    </div>
  );
};

export default NcsBanner;
